<template>
    <div id="print" class="course_main" :style="{'background-color': '#7BCBDA'}">
        <div class="back_nav" @click="goBack"><img src="../../assets/back_nav.png"/></div>

        <div class="prepare_page">
            <div class="entry">
                <div class="prepare_entry" @click="wordGameClick">
                    <div class="entry_img"><img src="@/Images/icon_word_game.png" alt=""/></div>
                    <div class="entry_text">词汇游戏</div>
                    <div class="entry_des">翻翻连线记单词</div>
                </div>
                <div class="prepare_entry" @click="languageGameClick">
                    <div class="entry_img"><img src="@/Images/icon_language_game.png" alt=""/></div>
                    <div class="entry_text">语言游戏</div>
                    <div class="entry_des">在句子中用单词</div>
                </div>
                <div class="dialogue_entry" @click="acknowledgeGameClick">
                    <div class="entry_img"><img src="@/Images/icon_acknowledge_game.png" alt=""/></div>
                    <div class="entry_text">认知游戏</div>
                    <div class="entry_des">边学知识边记单词</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import $ from "jquery";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            wordGameClick() {
                this.$router.push({name: "PCardGame", query: {lessonId: this.lessonId}});
            },
            languageGameClick() {
                // 语言游戏
                this.$router.push({name: "PChoiceQuestion", query: {lessonId: this.lessonId}});
            },
            acknowledgeGameClick() {
                // 认知游戏
                this.$router.push({name: "PDropQuestion", query: {lessonId: this.lessonId, type: 2}});
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            showStatusWhite:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (that.isAppAndroid()) {
                    window.note.changeStatusStyle(status);
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(this.$route.query.lessonId);

            setTimeout(() => {
                that.hideStatusAndStopAudio();
                that.lessonId = vLessonId;
                transformView();
            }, 200);
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhite(0);
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatusWhite(1);
            next();
        },
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .course_main {
        width: 100%;
        height: 100%;
    }

    .prepare_page {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
    .entry {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .entry .entry_img {
        width: 140px;
        height: 140px;
        background-color: white;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .entry .entry_img img {
        width: 100px;
        height: 100px;
    }
    .entry .prepare_entry {
        margin-right: 60px;
    }
    .entry .dialogue_entry {
    }
    .entry_text {
        width: 140px;
        margin-top: 20px;
        text-align: center;
        font-size: 17px;
        color: #ffffff;
        font-weight: bold;
    }
    .entry_des {
        width: 140px;
        margin-top: 5px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
    }

</style>
